<template>
	<div class="tab" data-name="gradeInfo" data-type="table">
		<h3>فرم مدارک فنی حرفه ای</h3>
		<p>[چناچه دوره آموزشی در آموزشگاه های فنی حرفه ای یاگواهی نامه دوره خاصی را دارید درج نمایید]</p>
		<table class="table table-bordered">
			<thead>
				<tr>
					<td>عنوان دوره</td>
					<td>مدت دوره</td>
					<td>نام اموزشگاه و مدرک اخذ شده</td>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>
						<input type="text" data-row="0" class="form-control" data-name="topic" />
					</td>
					<td>
						<input type="text" data-row="0" class="form-control" data-name="duration" />
					</td>
					<td>
						<input type="text" data-row="0" class="form-control" data-name="academy" />
					</td>
				</tr>
				<tr>
					<td>
						<input type="text" data-row="1" class="form-control" data-name="topic" />
					</td>
					<td>
						<input type="text" data-row="1" class="form-control" data-name="duration" />
					</td>
					<td>
						<input type="text" data-row="1" class="form-control" data-name="academy" />
					</td>
				</tr>
				<tr>
					<td>
						<input type="text" data-row="2" class="form-control" data-name="topic" />
					</td>
					<td>
						<input type="text" data-row="2" class="form-control" data-name="duration" />
					</td>
					<td>
						<input type="text" data-row="2" class="form-control" data-name="academy" />
					</td>
				</tr>
			</tbody>
		</table>
	</div>

</template>
<script>
	export default {
		props: {
			init: {
				type: Function,
			},
			contract: {
				type: Object,
			},
		},
		change(e)
		{
			this.$emit("change", e.target);
		},

		mounted()
		{
			this.init();
		},

	}
</script>
